/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

import { types } from 'mobx-state-tree'
import { QueryBuilder } from 'mst-gql'
import { ModelBase } from './ModelBase'
import { GameModeTagEnumType } from './GameModeTagEnum'
import { RootStoreType } from './index'

/**
 * UserGameScheduleBase
 * auto generated base class for the model UserGameScheduleModel.
 */
export const UserGameScheduleModelBase = ModelBase.named('UserGameSchedule')
  .props({
    __typename: types.optional(types.literal('UserGameSchedule'), 'UserGameSchedule'),
    _id: types.identifier,
    actionTime: types.union(types.undefined, types.number),
    blindTimer: types.union(types.undefined, types.number),
    createdAt: types.union(types.undefined, types.frozen()),
    gameKind: types.union(types.undefined, GameModeTagEnumType),
    hash: types.union(types.undefined, types.string),
    hostId: types.union(types.undefined, types.frozen()),
    hostName: types.union(types.undefined, types.string),
    name: types.union(types.undefined, types.string),
    scheduleTime: types.union(types.undefined, types.frozen()),
    startingChips: types.union(types.undefined, types.number),
    updatedAt: types.union(types.undefined, types.frozen()),
    usersToNotify: types.union(types.undefined, types.null, types.array(types.string))
  })
  .views((self) => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class UserGameScheduleModelSelector extends QueryBuilder {
  get _id() {
    return this.__attr('_id')
  }
  get actionTime() {
    return this.__attr('actionTime')
  }
  get blindTimer() {
    return this.__attr('blindTimer')
  }
  get createdAt() {
    return this.__attr('createdAt')
  }
  get gameKind() {
    return this.__attr('gameKind')
  }
  get hash() {
    return this.__attr('hash')
  }
  get hostId() {
    return this.__attr('hostId')
  }
  get hostName() {
    return this.__attr('hostName')
  }
  get name() {
    return this.__attr('name')
  }
  get scheduleTime() {
    return this.__attr('scheduleTime')
  }
  get startingChips() {
    return this.__attr('startingChips')
  }
  get updatedAt() {
    return this.__attr('updatedAt')
  }
  get usersToNotify() {
    return this.__attr('usersToNotify')
  }
}
export function selectFromUserGameSchedule() {
  return new UserGameScheduleModelSelector()
}

export const userGameScheduleModelPrimitives =
  selectFromUserGameSchedule()._id.actionTime.blindTimer.createdAt.gameKind.hash.hostId.hostName.name.scheduleTime
    .startingChips.updatedAt.usersToNotify
